import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  integrationName: string
  onClose: () => void
  onClickUninstall: () => void
}

export const UninstallModal = ({ integrationName, onClose, onClickUninstall }: Props) => {
  const translations = {
    title: i18n.t('marketplace.company_uninstall_modal.title', {
      integration_name: integrationName,
    }),
    description: i18n.t('marketplace.company_uninstall_modal.description', {
      integration_name: integrationName,
    }),
    cancel: i18n.t('marketplace.company_uninstall_modal.cancel'),
    submit: i18n.t('marketplace.company_uninstall_modal.submit'),
  }

  return (
    <Modal
      illustration="uninstall"
      title={translations?.title || ''}
      description={translations?.description || ''}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>{translations?.cancel || ''}</Button>
          <Button onClick={onClickUninstall}>{translations?.submit || ''}</Button>
        </>
      }
    />
  )
}
